import React, { useState } from 'react';
import { CheckCircle, AlertCircle, AlertTriangle, Info, X } from 'lucide-react';
import useNotificationStore from '../store/useNotificationStore';

const Notification = () => {
  const {
    notification,
    clearNotification,
    clearTimeout: clearNotificationTimeout,
    resetTimeout: resetNotificationTimeout,
  } = useNotificationStore();
  const [isHovered, setIsHovered] = useState(false);

  if (!notification) return null;

  const { type, message } = notification;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className='w-5 h-5 flex-shrink-0' />;
      case 'error':
        return <AlertCircle className='w-5 h-5 flex-shrink-0' />;
      case 'warning':
        return <AlertTriangle className='w-5 h-5 flex-shrink-0' />;
      case 'info':
        return <Info className='w-5 h-5 flex-shrink-0' />;
      default:
        return <Info className='w-5 h-5 flex-shrink-0' />;
    }
  };

  const getStyle = () => {
    switch (type) {
      case 'success':
        return {
          background: 'var(--bg-card)',
          border: '1px solid var(--brand)',
          color: 'var(--brand)',
        };
      case 'error':
        return {
          background: 'var(--bg-card)',
          border: '1px solid rgba(239,68,68,0.6)',
          color: '#ef4444',
        };
      case 'warning':
        return {
          background: 'var(--bg-card)',
          border: '1px solid rgba(234,179,8,0.6)',
          color: '#ca8a04',
        };
      case 'info':
        return {
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          color: 'var(--text-muted)',
        };
      default:
        return {
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          color: 'var(--text-muted)',
        };
    }
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
    clearNotificationTimeout();
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    const duration =
      notification?.type === 'error' ? 5000 : notification?.type === 'warning' ? 5000 : 3000;
    resetNotificationTimeout(duration);
  };

  const toastStyle = getStyle();

  return (
    <div className='fixed top-4 left-1/2 transform -translate-x-1/2 z-[9999] animate-slide-down'>
      <div
        className='px-5 py-3 rounded-xl shadow-lg flex items-center gap-3 min-w-[300px] max-w-[480px] cursor-default'
        style={{
          ...toastStyle,
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {getIcon()}
        <span
          className='font-medium flex-1 text-sm'
          style={{ color: 'var(--text-primary)' }}
        >
          {message}
        </span>
        <button
          onClick={clearNotification}
          className='hover:opacity-70 transition-opacity cursor-pointer'
          aria-label='Close notification'
          style={{ color: 'var(--text-muted)' }}
        >
          <X className='w-4 h-4' />
        </button>
      </div>
    </div>
  );
};

export default Notification;
